(window as any).__zone_symbol__PASSIVE_EVENTS = [
  'touchstart',
  'touchend',
  'mouseenter',
  'mouseout',
  'mousedown',
  'mouseup'
];
